import { TypedDocumentNode, gql } from "@apollo/client";
import { Capability, CareerConsultantSection } from "./types";

export type CapabilitiesQueryResponseType = {
  me: {
    id: string;
    capabilities: Capability;
    roles: string[];
    universityLegacyIds: string[];
  };
};

export const CAPABILITIES_QUERY: TypedDocumentNode<CapabilitiesQueryResponseType> = gql`
  query MeQuery {
    me {
      id
      capabilities {
        domains
        permissions
      }
      roles
      universityLegacyIds
    }
  }
`;

export type CareerConsultantSectionsQueryResponseType = {
  careerConsultantSections: CareerConsultantSection[];
};

export const CAREER_CONSULTANT_SECTIONS_QUERY: TypedDocumentNode<CareerConsultantSectionsQueryResponseType> = gql`
  query CareerConsultantSectionsQuery {
    careerConsultantSections {
      id
      name
      legacyId
    }
  }
`;

export type SectionLegacyIdsQueryResponseType = {
  me: {
    id: string;
    sectionLegacyIds: string[];
  };
};

export const SECTION_LEGACY_IDS_QUERY: TypedDocumentNode<SectionLegacyIdsQueryResponseType> = gql`
  query MeSectionLegacyIdsQuery {
    me {
      id
      sectionLegacyIds
    }
  }
`;
